import React, { useState, useEffect, forwardRef } from "react";
import { Dialog, AppBar, Toolbar, IconButton, Typography, Slide } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import LoadingComponent from "../LoadingComponent";
import { DB } from "../../constants";
import { DetectNetwork, BusinessLogic } from "../../utilities";
import "./style.css";
import { useTranslation } from 'react-i18next';

const Transition = forwardRef(function Transition(
    props, ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;
const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
    standardFontDataUrl: 'standard_fonts/',
};


const CustomizedPdfDialog = (props) => {
    const { t: translate } = useTranslation();
    const {
        open,
        id,
        pdfUrl,
        handleClose
    } = props

    const { online } = DetectNetwork()
    const [pdfViewer, setPdfViewer] = useState("")
    const [pages, setPages] = useState(null);
    const [errorMessage, setErrorMessage] = useState("")
    const [downloading, setDownloading] = useState(false)

    const getPdf = async () => {
        setDownloading(true)
        setErrorMessage("")
        if (pdfUrl) {
            let pdfData;
            // 1. Si l'URL est absolue (elle commence par http), on la fetch directement en natif
            if (pdfUrl.startsWith('http://') || pdfUrl.startsWith('https://')) {
                try {
                    const response = await fetch(pdfUrl);
                    if (!response.ok) throw new Error();
                    pdfData = await response.blob();
                } catch (e) {
                    console.error("Erreur lors du fetch direct du PDF:", e);
                    pdfData = null;
                }
            } else {
                // 2. Si c'est un chemin relatif, on applique votre nettoyage et on passe par BusinessLogic
                const cleanPdfUrl = pdfUrl.startsWith('/') ? pdfUrl.substring(1) : pdfUrl;
                pdfData = await BusinessLogic.updatePdf(cleanPdfUrl);
            }
            if(!pdfData){
                setDownloading(false)
                setErrorMessage(translate('noConnection'))
                return
            }
            console.log(pdfData)
            let reader = new FileReader();
            reader.readAsDataURL(pdfData);
            reader.onloadend = async () => {
                let base64String = reader.result;
                base64String = base64String.substr(base64String.indexOf(',') + 1)
                setPdfViewer(base64String)
            };
        }
        else {
            setErrorMessage(translate('failOpenPdf'))
        }
        setDownloading(false)
    }

    function onDocumentLoadSuccess({ numPages }) {
        setPages(numPages);
    }

    const checkError = () => {
        return errorMessage.length > 0 ? <p>{errorMessage}</p> : null
    }

    useEffect(() => {
        if (open) {
            getPdf()
        }
        else {
            setPdfViewer("")
        }
    }, [open])

    const DownloadingComponent = () => {
        return <div className="mx-2 my-4">
            <LoadingComponent label={translate('downloadingPdf')} />
        </div>
    }

    const OpeningComponent = () => {
        return <div className="mx-2 my-4">
            <LoadingComponent label={translate('openingPdf')} />
        </div>
    }

    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        backgroundColor: "#eee",
                        boxShadow: "none",
                        height: "100%"
                    },
                }}
            >
                <AppBar sx={{ position: 'relative', backgroundColor: "#fbd200", color: "black" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            {id}.pdf
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className="pdf-viewer-container">
                    {downloading ? <DownloadingComponent /> : null}
                    {pdfViewer !== "" ? <div className="pdf-container">
                        <Document
                            file={`data:application/pdf;base64,${pdfViewer}`}
                            loading={<OpeningComponent />}
                            noData={translate('failOpenPdf')}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={(error) => console.log("Inside Error", error)}
                            options={options}
                        >
                            {Array.from(new Array(pages), (el, index) => (
                                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                            ))}
                        </Document>
                    </div> : checkError()}
                </div>
            </Dialog>
        </div>
    );
}

export default CustomizedPdfDialog;